module.exports = __webpack_public_path__ + "static/media/home_page_capy_background@2x.6f150e91.png";